/* eslint-disable import/no-dynamic-require */
const entities_obj = require(`./${process.env.version}/entities`)
const pages = require(`./${process.env.version}/pages`)

const entities = entities_obj.list

export { entities, pages }
